import type { Trigger, PopupInstance, TriggerConfig } from '../types';

export class ExitIntentTrigger implements Trigger {
	private handler: ((e: MouseEvent) => void) | null = null;
	private fired = false;

	init(popup: PopupInstance, config: TriggerConfig): void {
		const sensitivity = config.sensitivity || 20;

		this.handler = (e: MouseEvent) => {
			if (this.fired) return;
			if (e.clientY <= sensitivity) {
				this.fired = true;
				popup.show();
			}
		};

		document.addEventListener('mouseout', this.handler);
	}

	destroy(): void {
		if (this.handler) {
			document.removeEventListener('mouseout', this.handler);
			this.handler = null;
		}
	}
}
